import { useSelector } from "react-redux";

export default function useAuthUser() {
  const authUser = useSelector((state) => state?.auth?.user);
  const userCompany = useSelector((state) => state?.auth?.company);

  return { authUser: authUser || "", userCompany: userCompany || "" };
}
